import React from 'react'
import {Container} from 'react-bootstrap'
import BenersJson from 'json/dashboard/beners'
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import './style.css'

export default function Bener() {

    return (
        <Container className="dashboard-beners">
         <Carousel autoPlay infiniteLoop={true} className="justify-content-md-center beners">
        {
            BenersJson.map((item, i) => {
                return (
                       <img key={i} src={item.src} alt={item.alt} />
                )
            })
        }
       </Carousel>
     </Container>
 )
}
